document.addEventListener("DOMContentLoaded", notifyPopupOpen, {once:true});

function notifyPopupOpen(){
  // Handle click on links with href="#drop-form" or "#wear-form"
  document.querySelectorAll('a[href="#drop-form"], a[href="#wear-form"]').forEach(function(link) {
    link.addEventListener('click', function(){
      document.querySelector('.store-online-or-offline').classList.add('popup-show');

      var Notification = this.getAttribute('notification');
      // console.log(Notification,'Notification');
      if (Notification) {
        document.querySelector('.store-online-or-offline input[name="User From"]').value = Notification;
      }
    
      if (this.getAttribute('current-product')) {
        var CurrentProductUrl = this.getAttribute('current-product');
        var CurrentProductTitle = this.getAttribute('product-title');

        document.querySelector('.store-online-or-offline input[name="Url"]').value = 'https://www.wearcomet.com' + CurrentProductUrl;
        document.querySelector('.store-online-or-offline input[name="Title"]').value = CurrentProductTitle;
      }

      // Populate product identifiers
      var productId = this.getAttribute('data-product-id');
      var variantId = this.getAttribute('data-variant-id');
      var productSku = this.getAttribute('data-product-sku');

      var skuInput = document.getElementById('notify-product-sku');
      var variantInput = document.getElementById('notify-variant-id');
      var pidInput = document.getElementById('notify-product-id');

      if (skuInput) skuInput.value = productSku || '';
      if (variantInput) variantInput.value = variantId || '';
      if (pidInput) pidInput.value = productId || '';
    });
  });
}

// Handle popup close button click
document.addEventListener('click', function(e) {
  if (e.target.closest('.popup-close') || e.target.matches('.store-online-or-offlines.modal-overlay')) {
    const storeForm = document.querySelector('.store-online-or-offline');
    if(storeForm && storeForm.classList.contains('popup-show')){
      storeForm.classList.remove('popup-show');
      
      setTimeout(() => {
        storeForm.style.visibility = 'hidden';
        const overlay = document.querySelector('.store-online-or-offlines.modal-overlay');
        if (overlay) overlay.style.display = 'none';

        var ShowForm = document.getElementById('notify_comet_form');
        if (ShowForm) {
          ShowForm.style.display = "block";
          ShowForm.reset();
          document.querySelector('.store-online-or-offline').classList.remove('thank_you_screen');
        }
        const thankYou = document.querySelector('.store-online-or-offline .thank-you-message');
        if (thankYou) thankYou.style.display = 'none';
        const titles = document.querySelector('.store-online-or-offline #form-titles');
        if (titles) titles.style.display = 'block';
      }, 400);
    }
  }
});

// Handle modal overlay click
document.addEventListener('click', function(e) {
  if (e.target.matches('.store-online-or-offlines.modal-overlay')) {
    var storeForm = document.querySelector('.store-online-or-offline');
    if(storeForm.classList.contains('popup-show')){
      storeForm.classList.remove('popup-show');
    }

    setTimeout(() => {
      var ShowForm = document.getElementById('notify_comet_form');
      ShowForm.style.display = "block";
      document.querySelector('.store-online-or-offline .thank-you-message').style.display = 'none';
      document.querySelector('.store-online-or-offline #form-titles').style.display = 'block';
      ShowForm.reset();
    }, 1000);
  }
});
  
window.addEventListener("load", function() {
  // Update Variant
  document.addEventListener('product:variant:changed', function(e){
    const data = e['detail'];
    console.log(data, "DATA")
    const sizeSelector = document.getElementById('product-size-select');
    if(data && data['variant']){
      const variant_name = data['variant']['name'];
      window.wc_current_selected_variant = variant_name;

      if (sizeSelector) {
          for (let i = 0; i < sizeSelector.options.length; i++) {
              if (sizeSelector.options[i].value === variant_name) {
                  sizeSelector.selectedIndex = i;
                  break;
              }
          }

          // Sync dropdown with variant.option2
          if (data['variant']['option2']) {
            sizeSelector.value = String(data['variant']['option2']);
          }
      }

      // Update product identifiers on variant change
      const variantInput = document.getElementById('notify-variant-id');
      const skuInput = document.getElementById('notify-product-sku');
      if (variantInput) variantInput.value = data['variant']['id'] || '';
      if (skuInput) skuInput.value = data['variant']['sku'] || '';

    }else{
      window.wc_current_selected_variant = null;
      if (sizeSelector) {
        sizeSelector.selectedIndex = 0;
      }
    }
    // console.log(window.wc_current_selected_variant);
  });
});

function notifyFormHandle() {
  const form = document.getElementById('notify_comet_form');
  if (!form) return;

  // Prevent duplicate event listeners
  if (form.dataset.listenerAttached === "true") return;
  form.dataset.listenerAttached = "true";

  // Update variant ID and SKU when size dropdown changes
  const sizeSelect = document.getElementById('product-size-select');
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      var selectedSize = this.value;
      var variants = window.notifyMeVariants || [];
      var matched = variants.find(function (v) {
        return String(v.option1) === selectedSize || String(v.option2) === selectedSize;
      });
      var variantInput = document.getElementById('notify-variant-id');
      var skuInput = document.getElementById('notify-product-sku');
      if (matched) {
        if (variantInput) variantInput.value = matched.id;
        if (skuInput) skuInput.value = matched.sku || '';
      }
    });
  }

  const storeTypeInput = form.querySelector('input[name="Store type"]');

  form.addEventListener("submit", function (e) {
    e.preventDefault();
  
    const clickedButton = e.submitter;
    if (!clickedButton) return;
  
    const storeType = clickedButton.dataset.storeType;
    if (storeTypeInput && storeType) {
      storeTypeInput.value = storeType;
    }
  
    const loader = clickedButton.querySelector('.form-btn-loader');
    const btnText = clickedButton.querySelector('span');
  
    if (loader) loader.style.display = "block";
    if (btnText) btnText.style.display = "none";
  
    // Disable all submit buttons
    form.querySelectorAll('.store-online-or-offline .submit-button').forEach(btn => btn.disabled = true);
  
    const data = new FormData(form);
    if (window.wc_current_selected_variant) {
      // data.append('Variant Name', window.wc_current_selected_variant);
    }
  
    fetch(form.action, {
      method: 'POST',
      body: data,
    })
    .then(() => {
      form.style.display = "none";
      const formTitles = document.getElementById('form-titles');
      if (formTitles) {
        formTitles.style.setProperty("display", "none");
      }
      const thankYouMessage = document.querySelector('.store-online-or-offline .thank-you-message');
      if (thankYouMessage) {
        thankYouMessage.style.setProperty("display", "block");
        document.querySelector('.store-online-or-offline').classList.add('thank_you_screen');
      }
    })
    .catch((err) => {
      console.error("Form submit error:", err);
    })
    .finally(() => {
      if (loader) loader.style.display = "none";
      if (btnText) btnText.style.display = "block";
  
      // Re-enable all submit buttons
      form.querySelectorAll('.store-online-or-offline .submit-button').forEach(btn => btn.disabled = false);
    });
  });
}

document.addEventListener("DOMContentLoaded", notifyFormHandle);